export default "__VITE_ASSET__D0PxiG$3__"